export type IUserOrderUpdateStatusParams = {
  id: number;
  place_id: number;
  status: number;
  cancellation_reason?: string;
};
export type IPartialSumParams = {
  user_id: number;
  data: string;
  time: string;
  place_id: number;
};

export class UserOrderStatus {
  public static STATUS_PEDIDO_PENDENTE = 1;
  public static STATUS_PEDIDO_PREPARACAO = 2;
  public static STATUS_PEDIDO_CANCELADO_LOJA = 3;
  public static STATUS_PEDIDO_CANCELADO_CLIENTE = 4;
  public static STATUS_PEDIDO_PREPARADO = 5;
  public static STATUS_PEDIDO_AGUARDANDO_RETIRADA = 6;
  public static STATUS_PEDIDO_A_CAMINHO = 7;
  public static STATUS_PEDIDO_DEVOLVIDO = 8;
  public static STATUS_PEDIDO_ENTREGUE = 9;
  public static STATUS_PEDIDO_EXPIRADO = 10;
  public static STATUS_PEDIDO_SOLICITACAO_CANCELAMENTO = 11;
  public static STATUS_PEDIDO_ENVIADO = 12;
  public static STATUS_PEDIDO_CANCELADO_BOT = 13;
  public static STATUS_PEDIDO_CONCLUIDO = 14;
}

/* COPIADO DO BACKEND:
  // Status dos pedidos
  public const int STATUS_PEDIDO_PENDENTE = 1;
  public const int STATUS_PEDIDO_PREPARACAO = 2;
  public const int STATUS_PEDIDO_CANCELADO_LOJA = 3;
  public const int STATUS_PEDIDO_CANCELADO_CLIENTE = 4;
  public const int STATUS_PEDIDO_PREPARADO = 5;
  public const int STATUS_PEDIDO_AGUARDANDO_RETIRADA = 6;
  public const int STATUS_PEDIDO_A_CAMINHO = 7;
  public const int STATUS_PEDIDO_DEVOLVIDO = 8;
  public const int STATUS_PEDIDO_ENTREGUE = 9;
  public const int STATUS_PEDIDO_EXPIRADO = 10;
  public const int STATUS_PEDIDO_SOLICITACAO_CANCELAMENTO = 11;
  public const int STATUS_PEDIDO_ENVIADO = 12;
  public const int STATUS_PEDIDO_CANCELADO_BOT = 13;
  public const int STATUS_PEDIDO_CONCLUIDO = 14;
 */